<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
            <p class="text-h4 text--primary">
                <TextHeading :level=3>Harmonogram Szkoleń</TextHeading>
            </p>
            <v-simple-table fixed-header>
                <thead>
                    <tr>
                        <th class="text-left">
                            Szkolenie
                        </th>
                        <th class="text-left">
                            Miejsce
                        </th>
                        <th class="text-left">
                            Termin szkolenia
                        </th>
                        <th class="text-left">
                            Formularz zgłoszenia
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item, index) in schedule"
                        :key="index"
                    >
                        <td>{{ item.name }}</td>
                        <td>{{ item.place }}</td>
                        <td>{{ item.date }}</td>
                        <td><v-btn small depressed :to="`/trainings/schedule_form?training_name=${item.name}&date=${item.date}`">{{ $t('go_to_form') }}</v-btn></td>
                    </tr>
                </tbody>
            </v-simple-table>
          </div>
        </v-col>
      </v-row>
    </v-container>
</template>
<script>
    import TextHeading from "@/modules/TextHeading";
    export default {
  
    components: {TextHeading},

    data: () => ({
        schedule: [
            {
                name: 'Udzielanie zamówień w projektach w perspektywie finansowej 2021-2027',
                place: 'Szczecin - Hotel Ibis Style Stare Miasto Ul. Panieńska 10',
                date: '24.04.2023 r.',
            },
            {
                name: 'Kwalifikowalność wydatków w perspektywie finansowej 2021-2027',
                place: 'Szczecin - Hotel Ibis Style Stare Miasto Ul. Panieńska 10',
                date: '25.04.2023 r.',
            },
            {
                name: 'Regionalny Program Operacyjny Województwa Zachodniopomorskiego na lata 2021 -2027',
                place: 'Szczecin - Hotel Ibis Style Stare Miasto Ul. Panieńska 10',
                date: '26.04.2023 r.',
            },
        ],
    })
  }
</script>

<style lang="scss">

.cellWidth {
  width: 25%;
}
.rowMargin {
    margin-top: 5px;
    margin-bottom: 5px;
}

</style>
